import * as moment from 'moment';
import { useEffect, useState } from 'react';
import { IMicrositeRecipientForList } from '@nkr/models/microsites';
import { IBusinessCardsRequest } from '@nkr/models/microsites/business-cards-request';
import { Button, ControlLabel, Form, FormControl, FormGroup, MenuItem, Modal } from 'react-bootstrap';
import useBusinessCardsRequest from '@nkr/store/microsites/hooks/use-business-cards-request';

type TProps = {
    recipient: IMicrositeRecipientForList,
    onUpdate?: (request: IBusinessCardsRequest) => void
};

export default function BusinessCardsRequest({ recipient, onUpdate }: TProps) {
    const { request, update } = useBusinessCardsRequest(recipient.id);
    const [show, setShow] = useState<boolean>(false);
    const [size, setSize] = useState<number>(1);

    const thirtyDaysAgo = moment().subtract(30, 'days');
    const cardBatchDate = moment(request?.cardBatchDateTime);
    const businessCardsDate = moment(request?.businessCardsRequestDate);

    const recentlyRequested = (cardBatchDate.isValid() && cardBatchDate.isAfter(thirtyDaysAgo))
        || (businessCardsDate.isValid() && businessCardsDate.isAfter(thirtyDaysAgo));

    useEffect(() => {
        if (request && request.businessCardsRequestSize > 0) {
            setSize(request.businessCardsRequestSize);
        } else {
            setSize(1);
        }
    }, [request]);

    const handleCancel = () => {
        setShow(false);
        setSize(1);
    }

    const handleSubmit = () => {
        const val = { ...request, businessCardsRequestSize: size, businessCardsRequestDate: new Date() };
        update(val)
        setShow(false);
        setSize(1);
        onUpdate && onUpdate(val)
    }

    return (
        <>
            <MenuItem
                onClick={() => setShow(true)}
                disabled={recentlyRequested}
                title={recentlyRequested ? 'Business cards were recently requested for this recipient.' : ''}
            >
                Request Business Cards
            </MenuItem>

            <Modal backdrop='static' show={show} onHide={handleCancel}>
                <Modal.Header closeButton>
                    Request Business Cards for <strong>{recipient.fullName}</strong>
                </Modal.Header>
                <Modal.Body>
                    <Form >
                        <FormGroup>
                            <ControlLabel>Number of Sets:</ControlLabel>
                            <FormControl
                                componentClass='select'
                                value={size}
                                onChange={(e: any) => setSize(e.target.value)}
                            >
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                            </FormControl>
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={handleSubmit}>Confirm</Button>
                    <Button onClick={handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
